export default "__VITE_ASSET__Bvao0Qcb__"